
var filtering_referenced = {};
var filtering_typereferenced = {};

function addItemRef(item,parentItem){
    item.ref = item.title.replace(/[^a-zA-Z0-9]/g, "").replace(/ /g,'').toLowerCase();
    if(parentItem){
        if (parentItem.ref){
            item.parentref = parentItem.ref;
        }
        if (parentItem.type){
            item.parenttype = parentItem.type;
        }
    }
    filtering_referenced[item.ref]=item;
    if (item.type && !filtering_typereferenced[item.type]){
        filtering_typereferenced[item.type] = [];
    }
    if (item.parenttype && !filtering_typereferenced[item.parenttype]){
        filtering_typereferenced[item.parenttype] = [];
    }

    if(item.children){
        for(var i =0;i<item.children.length;i++){
            item.children[i] = addItemRef(item.children[i],item);
        }
    }else if(item.nodes){
        var nodes_toadd = [];
        nodes_toadd = nodes_toadd.concat(item.nodes.sections);
        nodes_toadd = nodes_toadd.concat(item.nodes.rows);
        nodes_toadd = nodes_toadd.concat(item.nodes.seats);
        if(item.type){
            filtering_typereferenced[item.type] = filtering_typereferenced[item.type].concat(nodes_toadd);
        }else{
            filtering_typereferenced[item.parenttype] = filtering_typereferenced[item.parenttype].concat(nodes_toadd);
        }
    }
    
    return item;
}
function filteringItemConstruct(item){
    item = addItemRef(item);
    if(!item.nodes){
        let dom = $("<div "+
        "class='drop accordionparent "+item.type+" flex spb'"+
        "data-ref='"+item.ref+"'>"+
            "<button class='accordionparent-wrap'>"+
            "<p>"+item.title+"</p>"+
            "<span class='interface-btn-standard-nosize'>"+
                "<i class='icon-arrow-right'></i>"+
            "</span>"+
            "</button>"+
            "<div class='accordion' data-ref='"+item.ref+"'></div>"+
        "</div>");
        //let domico = $();
        //dom = $($(dom).append(domico));
        $("#accordionContainer").append(dom);
        //let domaccordion = $("<div class='accordion' data-ref='"+item.ref+"'></div>");
        //$("#accordionContainer").append(domaccordion);
        filteringAccordionConstruct(item);
    }else{
        let dom = $("<div "+
                    "class='drop filter "+item.type+" flex spb'>"+
                    "<button "+
                    "data-ref='"+item.ref+"'"+
                    "onclick='filterBy(this)'>"+
                        "<p>"+item.title+"</p>"+
                    "</button>"+
                    "</div>");
        
        $("#accordionContainer").append(dom);
    }
                
}
function filteringInit(type){
    $("#accordionContainer").children().remove();
    for(var i = 0;i<filtering.filtering.length;i++){
        filteringItemConstruct(filtering.filtering[i]);
        //filteringAccordionConstruct(fObj);
    }
    menuAddEventListeners();

    return null;
}


function filteringAccordionConstruct(item){
    var accordion = $(".accordion[data-ref='"+item.ref+"']");
    if(typeof accordion !='null'){

        for (var i = 0; i < item.children.length; i++) {
            $(accordion).append(`
                <div class='filter' onclick='filterBy(this)' data-ref='`+item.children[i].ref+`'>
                    <span class="f-bull `+item.type+`">&bull;</span> `+item.children[i].title+`
                </div>`);
        }

    }
    return null;
}

function filteringSeatmapApply(){
    if(!filtering.ref){
        return 
    }

    var nodes = interf.filtering.nodes;
    var current_section = null;
    if(nodes.seats.length>0 || nodes.rows.length>0){
        var seatnodes = nodes.seats;
        var allseats = viewer.getNodesByType("seat");

        for(var i =0;i<allseats.length;i++){
            var seat = allseats[i].id;
            var seat_arr = seat.split("-");
            var concat_row = seat_arr[0]+"-"+seat_arr[1];
            current_section = seat_arr[0];
            if(nodes.rows.indexOf(concat_row)>-1){
                seatnodes = seatnodes.concat(seat);
            }
        }
        var nodes_toset = [];
        for(var i = 0;i<seatnodes.length;i++){
            if (current_section == seatnodes[i].split("-")[0]){
                nodes_toset = nodes_toset.concat(seatnodes[i]);
            }
        }
        if(nodes_toset.length >0){
            viewer.setAvailability("seat",seatnodes);
            interf.seatmap.nodes_selected = seatnodes;
        }
    }

}
function filteringTopviewApply(){
    if(interf.filtering.nodes.sections.length >0){
        viewer.setAvailability("section",interf.filtering.nodes.sections);
    }
    return;
}
function setBreadcrumbs(){
    var ref = interf.filtering.ref;
    let bc_val = "";
    interfaceBCResetColours();
    if(ref){
        let current_fil = filtering_referenced[ref];
        bc_val = "<span class='breadcrumbs-atitle'>"+filtering_referenced[ref].title+"</span>";
        if(current_fil.parentref){
            bc_val = filtering_referenced[current_fil.parentref].title+
            "<span class='fa-slash'>/</span>"+
            bc_val;
        }
        var type = current_fil.type;
        if(!type){
            type = current_fil.parenttype;
        }
        $(".bread-crumbs").find(".breadcrumbs-val").addClass(type);
        $(".section-lab").addClass(type);
        $(".row-lab").addClass(type);
        $(".seat-lab").addClass(type);
    }
    $(".breadcrumbs-val").html(bc_val);

}
function filterBy(element){    
    //console.log(interfaceGetCurrent());
    interfaceResetFiltering();
    // interfaceShareSetDefault();
    if(!$(element).hasClass("active")){
        removeOldFiltering();
        
        $(".filter").find("button").removeClass("active");
        var ref = $(element).data("ref");
        $(element).addClass("active");
        var nodes = filtering_referenced[ref].nodes;
        viewer.setAvailability("section",nodes.sections);
        interf.topview.nodes_selected = nodes.sections;
        interf.filtering.nodes = nodes;
        interf.filtering.ref = ref;
        $("#top-guide .section").addClass("hidden");
        if(interfaceGetCurrent()=='seatmap'){
            interfaceGoHome();
        }
    }else{
        $(".filter").find("button").removeClass("active");
        removeOldFiltering();
    }
    setBreadcrumbs();

    if(interfaceIsMobile()){
        menuClose();
    }
    return null;
}

function filteringGetRegular(){
    return Object.keys(filteringIdName.regular);
}

function removeOldFiltering(){
    //remove old filtering
    $(".filter").removeClass("active");
    var nodes = viewer.getNodesByTag("section","vipFilter");
    nodes = nodes.concat(viewer.getNodesByTag("section","regFilter"));
    //viewer.setNodesTag(nodes,null);
    viewer.setAvailability("section",viewer.getNodesByType("section"));

        $("#top-guide").removeClass("filtered");
        $(".section-lab").html("Section");
    
    //interfaceReset();
    return null;
}

var drop = document.getElementsByClassName("drop accordionparent");


function menuToggle(element){
    console.log(element)
    let action = $(element).attr("data-action");
    if(action=='open'){
        menuOpen();
    }else{
        menuClose();
    }
    return null;
}
function menuOpen(){
    $("#menu").attr("data-status","opened");
    $(".menu-btn").attr("data-action","close");
    if(interfaceIsMobile()){
        $(".menu-btn").find("i").removeClass("icon-menu").addClass("icon-arrow-down");
    }
    
    return null;
    
}
function menuClose(){
    $("#menu").attr("data-status","closed");
    $(".menu-btn").attr("data-action","open");
    $(".menu-btn").find("i").removeClass("icon-arrow-down").addClass("icon-menu");
    return null;
}
function menuBtnHide(){
    if(interfaceIsMobile()){
        $("#interface-btns-mobile .menu-btn").addClass("hidden");
    }else{
        $("#topbar .menu-btn").addClass("hidden");
    }
    return null;
}

function menuBtnShow(){
   if(!filtering.filtering.length){
       //***** Add hidden class to the btn dom
       //**** to remove the delay on hidden
        menuBtnHide();
        return;
   }
    if(interfaceIsMobile()){
        $("#interface-btns-mobile .menu-btn").removeClass("hidden");
    }else{
        $("#topbar .menu-btn").removeClass("hidden");
    }
    return null;
}

function topnavbtnsShow(){
    $(".topnav-btn").removeClass("hidden");
}
function topnavbtnsHide(){
    $(".topnav-btn").addClass("hidden");
}
function filteringMovetoSection(position){
    let current = viewer.getMapId();
    let node;
    if (navigation[current] && navigation[current][position] && navigation[current][position] !== 'none') {
        node = { id: navigation[current][position] };
        dvmLoadSeatmap(node);
    } else {
        console.log('Next section not found.');
        window.alert('Next section not found.');
    }
}

function breadcrumbsShowToggle(){
    if(interfaceIsMobile()){
        $("#interface-btns-mobile .bread-crumbs").removeClass("hidden");
        $("#topbar .bread-crumbs").addClass("hidden");
    }else{
        $("#topbar .bread-crumbs").removeClass("hidden");
        $("#interface-btns-mobile .bread-crumbs").addClass("hidden");
    }
    return null;
}

function breadcrumbsHide(){
    if(interfaceIsMobile()){
        $("#interface-btns-mobile .bread-crumbs").addClass("hidden");
    }else{
        $("#topbar .bread-crumbs").addClass("hidden");
    }
    return null;
}

function breadcrumbsMobileHide(){
    $("#interface-btns-mobile .bread-crumbs").addClass("hidden");

    return null;
}

function menuAddEventListeners(){

    let accordion_btn = $(".accordionparent").find("button");

    for (let i = 0; i < drop.length; i++) {
        accordion_btn[i].addEventListener("click", function() {
            var i = this.querySelector("i");
            if(i.classList.contains("icon-arrow-right")){
                i.classList.remove("icon-arrow-right");
                i.classList.add("icon-arrow-down");
            }else{
                i.classList.remove("icon-arrow-down");
                i.classList.add("icon-arrow-right");
            }
            var dropItem = $(this).next(".accordion");
            $(this).toggleClass("active");
            if ($(this).hasClass("active")) {
                $(dropItem).attr("style","height: auto");
            } else {
                $(dropItem).removeAttr("style");
            };
            interfaceLinkToShare();
        });
    }
    return null;
}